import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from './Contex/Product_Context';
import { AppMainProvider } from './Contex/MainDataContex';
import { CardProvider } from './Contex/AddCartContex';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <AppProvider>
     <AppMainProvider>
        <CardProvider>
           <App />
        </CardProvider>
     </AppMainProvider>
        
  </AppProvider>
   
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
